var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.00023H3C2.46957 4.00023 1.96086 4.21094 1.58579 4.58601C1.21071 4.96109 1 5.46979 1 6.00023V20.0002C1 20.5307 1.21071 21.0394 1.58579 21.4144C1.96086 21.7895 2.46957 22.0002 3 22.0002H17C17.5304 22.0002 18.0391 21.7895 18.4142 21.4144C18.7893 21.0394 19 20.5307 19 20.0002V13.0002M17.5 2.50023C17.8978 2.1024 18.4374 1.87891 19 1.87891C19.5626 1.87891 20.1022 2.1024 20.5 2.50023C20.8978 2.89805 21.1213 3.43762 21.1213 4.00023C21.1213 4.56284 20.8978 5.1024 20.5 5.50023L11 15.0002L7 16.0002L8 12.0002L17.5 2.50023Z",
    stroke: "#101828",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a06dccb21f5b012c29440aab48a56626.svg";
export { ForwardRef as ReactComponent };